export default "__VITE_ASSET__d58e976b__"